// Utility functions for student data manipulation

export const getName = (student) => {
  if (!student) return '';
  if (student.name) return student.name;
  // Check for surname (the actual field used in the database)
  if (student.firstName && student.surname) {
    return `${student.firstName} ${student.surname}`;
  }
  // Fallback to lastName for backwards compatibility
  if (student.firstName && student.lastName) {
    return `${student.firstName} ${student.lastName}`;
  }
  if (student.firstName) return student.firstName;
  if (student.displayName) return student.displayName;
  return 'Unknown Student';
};

export const getId = (student) => {
  if (!student) return null;
  return student.id || student._id || student.uid || null;
};

export const uniqKey = (student) => {
  if (!student) return null;
  const id = getId(student);
  const name = getName(student);
  // Create a unique key combining ID and name
  if (id) return `${id}-${name.replace(/\s+/g, '_').toLowerCase()}`;
  return `key-${name.replace(/\s+/g, '_').toLowerCase()}-${Date.now()}`;
};

export const getStudentClass = (student) => {
  if (!student) return '';
  return student.className || student.class || student.classId || '';
};

export const getStudentAvatar = (student) => {
  if (!student) return null;
  return student.photoURL || student.avatar || null;
};

export const formatStudentForDisplay = (student) => {
  if (!student) return null;
  return {
    id: getId(student),
    name: getName(student),
    firstName: student.firstName || getName(student).split(' ')[0],
    lastName: student.surname || student.lastName || getName(student).split(' ').slice(1).join(' '),
    surname: student.surname || student.lastName || getName(student).split(' ').slice(1).join(' '),
    className: getStudentClass(student),
    photoURL: getStudentAvatar(student),
    ...student
  };
};